import styled from "styled-components";

export const Header = styled.header`
display:flex;
justify-content: space-between;
align-items: center;

padding: 20px 20px;

border-bottom: 1px solid #FFFFFF;
font-size: 20px;
font-weight: 700;
text-transform: uppercase;

background-image: url("https://p4.wallpaperbetter.com/wallpaper/979/77/271/background-book-phone-hd-wallpaper-preview.jpg");
background-repeat: no-repeat;
background-size: cover;
`;